import { simpleFetch } from "./acCommon"
import { fetchAccountProfile } from "./acAccountProfile"


export const fetchPootsyExport = () => (dispatch, getState) => {
	let url = "/customers/data_exports/pootsy_export"
	let init = { method: "POST" }
	dispatch(simpleFetch(url, init, "POOTSY_DATA_REMOVAL"))
}

export const removePootsyData = () => (dispatch, getState) => {
	let url = "/customers/profile/forget"
	let init = { method: "DELETE" }
	dispatch(simpleFetch(url, init, "POOTSY_DATA_REMOVAL")).then(({ actionType }) => {
		if (actionType === "POOTSY_DATA_REMOVAL_SUCCESS") {
			dispatch(fetchAccountProfile())
		}
	})
}

export const affiliateDataExport = chosenAffiliateID => (dispatch, getState) => {
	let { currentUser } = getState().dataReducer
	let contract = currentUser.contracts.find(entry => entry.affiliateID === chosenAffiliateID)
	let url = "/customers/data_exports/affiliate_export"
	let init = { method: "POST", body: JSON.stringify({ customer_contract_id: contract.id }) }
	dispatch(simpleFetch(url, init, "ASK_AFFILIATE_DATA_EXPORT"))
}

export const askAffiliateDataRemoval = chosenAffiliateID => (dispatch, getState) => {
	let { currentUser } = getState().dataReducer
	let contract = currentUser.contracts.find(entry => entry.affiliateID === chosenAffiliateID)
	let url = "/customers/customer_contracts/" + contract.id + "/ask_affiliate_forget"
	let init = { method: "GET" }
	dispatch(simpleFetch(url, init, "ASK_AFFILIATE_DATA_REMOVAL")).then(({ actionType }) => {
		if (actionType === "ASK_AFFILIATE_DATA_REMOVAL_SUCCESS") {
			dispatch(fetchAccountProfile())
		}
	})
}

export const endAffiliateContract = chosenAffiliateID => (dispatch, getState) => {
	let { currentUser } = getState().dataReducer
	let contract = currentUser.contracts.find(entry => entry.affiliateID === chosenAffiliateID)
	let url = "/customers/customer_contracts/" + contract.id + "/disable"
	let init = { method: "PUT" }
	dispatch(simpleFetch(url, init, "END_AFFILIATE_CONTRACT"))
}



// WEBPACK FOOTER //
// ./src/actions/acAccountPrivacy.js